import { List, Map } from "immutable";
import moment from "moment";

import "seneca-common/features/assignments/common/consts";
import sortAscendingOrder from "seneca-common/utils/functions/sorting/sortAscendingOrder/";
import sortDescendingOrder from "seneca-common/utils/functions/sorting/sortDescendingOrder";

import Assignment from "../../../models/Assignment";
import { getAssignmentId, getDueDate, getStartDate } from "./assignment";

import { TimeWindowType } from "seneca-common/features/assignments/common/consts";
export function getVisibleAndFilteredAssignments(
  assignments: Map<string, Assignment>,
  timeWindow: TimeWindowType,
  now: moment.Moment
) {
  const { start } = timeWindow;
  let visibleAssignments = assignments;

  if (start) {
    visibleAssignments = assignments.filter(assignment =>
      now.isAfter(getStartDate(assignment))
    );
  }

  return getFilteredAndSortedAssignments(visibleAssignments, timeWindow, now);
}

export function getFilteredAndSortedAssignments(
  assignments: Map<string, Assignment>,
  timeWindow: TimeWindowType,
  now: moment.Moment
): List<Assignment> {
  const { start, end } = timeWindow;

  let filterAssignments;

  if (end === null) {
    filterAssignments = (assignment: any) =>
      start && start.isBefore(getDueDate(assignment));
  } else if (start === null) {
    filterAssignments = (assignment: any) =>
      end && end.isAfter(getDueDate(assignment));
  } else {
    filterAssignments = (assignment: any) =>
      start &&
      end &&
      start.isBefore(getDueDate(assignment)) &&
      end.isAfter(getDueDate(assignment));
  }

  // past assignments are sorted in descending order, upcoming assignments are sorted in ascending order
  const sortDesc = end && end.isSameOrBefore(now);

  return assignments
    .toList()
    .filter(filterAssignments)
    .sort((a1, a2) => {
      return sortDesc
        ? sortDescendingOrder(getDueDate(a1), getDueDate(a2))
        : sortAscendingOrder(getDueDate(a1), getDueDate(a2));
    });
}

export function getSortedAscendingAssignmentIds(
  assignments: Map<string, Assignment>
) {
  return assignments
    .toList()
    .sort((a1, a2) => sortAscendingOrder(getDueDate(a1), getDueDate(a2)))
    .map(getAssignmentId);
}
